import { Heart } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-border bg-secondary/30 py-6 sm:py-8">
      <div className="container mx-auto px-3 sm:px-4 text-center">
        <p className="font-display text-lg text-primary font-semibold">Bonjour Sobrancelhas</p>
        <p className="text-sm text-muted-foreground mt-2">Micropigmentação & Design de Sobrancelhas</p>

        <div className="mt-4 space-y-1 text-sm text-muted-foreground">
          <p>Rua Nadir, 130 - Gopouva - Guarulhos</p>
          <p>11 91910-3822</p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 mt-4 text-sm">
          <Link to="/privacidade" className="text-muted-foreground hover:text-primary transition-colors min-h-[44px] flex items-center">
            Política de Privacidade
          </Link>
          <span className="text-border hidden sm:inline">|</span>
          <Link to="/termos" className="text-muted-foreground hover:text-primary transition-colors min-h-[44px] flex items-center">
            Termos de Uso
          </Link>
          <span className="text-border hidden sm:inline">|</span>
          <Link to="/direitos-autorais" className="text-muted-foreground hover:text-primary transition-colors min-h-[44px] flex items-center">
            Direitos Autorais
          </Link>
        </div>

        <p className="text-xs text-muted-foreground mt-4 flex items-center justify-center gap-1">
          Feito com <Heart className="h-3 w-3 text-primary fill-primary" /> Bonjour Sobrancelhas
        </p>
      </div>
    </footer>
  );
}
